module.exports = __webpack_public_path__ + "static/media/service4.63a09087.svg";